import React from "react";

export const DetilPxContext = React.createContext();

export const OdontogramContext = React.createContext();
